import { render, staticRenderFns } from "./indx.vue?vue&type=template&id=16c5680b&scoped=true"
import script from "./indx.vue?vue&type=script&lang=js"
export * from "./indx.vue?vue&type=script&lang=js"
import style0 from "./indx.vue?vue&type=style&index=0&id=16c5680b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5680b",
  null
  
)

export default component.exports